import { useImmer } from "use-immer";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons/faTrashCan";

const Component = ({ config, onChange }) => {
  const scoreTemplate = {
    historyLookupMinutesMin: 0,
    historyLookupMinutesMax: 0,
    scoreOnMatch: 0,
  };
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  const addScore = () => {
    updateData((draft) => {
      draft.scores.push(structuredClone(scoreTemplate));
    });
  };

  const removeScore = (index) => {
    updateData((draft) => {
      draft.scores.splice(index, 1);
    });
  };

  return (
    <>
      <table className="config-table-double table-with-button">
        <thead>
          <tr>
            <th>
              History min <small>[minutes]</small>
            </th>
            <th>
              History max <small>[minutes]</small>
            </th>
            <th>Count min.</th>
            <th>Count max.</th>
            <th>Score</th>
            <th>
              <FontAwesomeIcon
                icon={faPlus}
                className="icon-clickable"
                onClick={addScore}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.scores.map((score, index) => (
            <tr key={index}>
              <td>
                <input
                  type="number"
                  max={score.historyLookupMinutesMax}
                  value={score.historyLookupMinutesMin}
                  step={1}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].historyLookupMinutesMin = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <input
                  type="number"
                  min={score.historyLookupMinutesMin}
                  max={0}
                  value={score.historyLookupMinutesMax}
                  step={1}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].historyLookupMinutesMax = e.target.value;
                    })
                  }
                />
              </td>
              <td>1</td>
              <td>999</td>
              <td>
                <input
                  type="number"
                  min={0}
                  value={score.scoreOnMatch}
                  step={0.1}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].scoreOnMatch = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <FontAwesomeIcon
                  icon={faTrashCan}
                  className="icon-clickable"
                  onClick={() => removeScore(index)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default Component;
